import React, { Component } from "react";
import { Link } from "gatsby";
import Layout from "../components/layout";
import "../css/style.css"
import PopupForm from "./popupForm";

class InstituteTabs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            time: 90000000
        }
    }

    handlePopupWindow = () => {
        this.setState({ time: Math.random() })
    }

  


render(){
  return(
    <div>
        <PopupForm time={this.state.time} />
    <div class="program-detail-banner-sec" style={{fontFamily: "caros"}}>
                <div class="container">
                    <div class="row"> 
                        <div class="col-12">
                            <div class="program-detail-banner-inner">
                                <ol class="transparentbreadcrumb breadcrumb">
                                    <li class="breadcrumb-item"><a href="/program-listing/">Programs </a></li> 
                                    <li class="breadcrumb-item"><a href="#">{this.props.GraduationType}</a></li>
                                    <li class="breadcrumb-item active">{this.props.ProgramName}</li>
                                </ol>
                                <div class="row" style={{fontFamily: "caros"}}>
                                    <div class="col-md-8">
                                        <div class="detail-banner-left">
                                            <div class="text-box">
                                                <h2>{this.props.ProgramName}</h2>
                                                <p>Get Your {this.props.DegreeType} degree in {this.props.DegreeArea} through The WorldGrad</p>
                                              <a id="book-councelling-btn" class="btn-default text-center" onClick={() => this.handlePopupWindow()}>Book a counselling session</a>
                                            </div>
                                            <div class="text-inner">
                                            {this.props.ProgramSponserdImage ?
                                                ( <div><p>Program offered by</p>
                                                 <ul style={{padding: "0 0 29px"}}>
                                                    <li>
                                                      <div class="program-landing">
                                                           {this.props.UniversityLogo !== null ? (
                                                                <div class="UnimasterLogo">
                                                                    {/* <img src="https://res.cloudinary.com/worldgrad/image/upload/v1614069772/worldgrad/countries/UniSmarter_Logo_Stacked_REV-min_mjmgar.png" alt="" class="img-fluid" /> */}
                                                                <img src={this.props.ProgramSponserdImage2}/>
                                                                </div>):(<div></div>)
                                                            }
                                                      </div>
                                                    </li>
                                                    <li>
                                                        <div class="program-landing">
                                                           {this.props.UniversityLogo !== null ? (
                                                                <div class="logo-holder">
                                                                    <img src={this.props.ProgramSponserdImage} alt="" class="img-fluid" />
                                                                </div>):(<div></div>)
                                                            }
                                                        </div>
                                                    </li>
                                                </ul>

                                                  </div> ) :("")}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="detail-banner-right">
                                            <div class="detail-banner-right-box">
                                                <div class="image-holder">
                                                  <img src="https://media.publit.io/file/TheWorldgrad/2Programdetailedpage/Savings.png" alt=""/> 
                                                </div>
                                                <div class="text-box">
                                                    <h3>Savings of up to INR 20L with The WorldGrad</h3>
                                                </div>
                                            </div>
                                            <div class="detail-banner-right-box">
                                                <div class="image-holder">
                                                  <img style={{width: "70%", position: "relative", top: "-2px", left: "2px"}} src="https://media.publit.io/file/TheWorldgrad/2Programdetailedpage/admission-1.png" alt=""/> 
                                                </div>
                                                <div class="text-box">
                                                    <h3>Hassle free admissions to overseas campus</h3>
                                                </div>
                                            </div>
                                            <div class="detail-banner-right-box">
                                                <div class="image-holder">
                                                  <img style={{ width: "80%", position: "relative", bottom: "4px", left: "1px" }} src="https://media.publit.io/file/TheWorldgrad/2Programdetailedpage/refund.png" alt=""/> 
                                                </div>
                                                <div class="text-box">
                                                    <h3>Assured refund in case of visa rejection*</h3>
                                                    <p class="refund-policy">*As per refund policy</p>
                                                </div>
                                                
                                            </div>
                                        
                                        </div>
                                    </div>
                                </div>
                            </div>  
                        </div> 
                    </div>
                </div>
            </div>
            {this.props.GraduationType === "Undergraduate" ?
            <div class="monthly-duration-sec" style={{backgroundColor: "#f8f8fa"}}>
                <div class="container">
                    <div class="row">
                        <div class="col-12"> 
                        {this.props.Term2Info ?
                            <ul>
                                <li class="mrtps-trpe">
                                <p>Total duration</p>
                                    <h4>{this.props.ProgramDuration}</h4>
                                   <hr className="program-detail-horizontal-line" />
                                </li>
                                {/* <li>
                                    <h4>16 subjects</h4>
                                    <p>Curriculum</p>
                                </li> */}
                                <li>
                                <p>Year 1 : Stage A (online) </p>
                                <a href={this.props.programLink}>
                                        <h4 style={{color: "#F0A500"}}>{this.props.Term1Info}</h4>
                                    </a>   
                                    <hr className="program-detail-horizontal-line" />
                                </li>
                                <li class="mrtps-trpe">
                                <p>Year 1 : Stage B (on campus) </p>
                                    <h4>{this.props.Term2Info}</h4>
                                    <hr className="program-detail-horizontal-line" />
                                </li>
                                <li>
                                <p>Year 2 / 3 (on campus)</p>
                                    <h4>{this.props.Year3Info}</h4>
                                </li>
                            </ul>
                            :
                            <ul>
                                <li class="mrtps-trpe">
                                <p>Total duration</p>
                                        <h4>{this.props.ProgramDuration}</h4>
                                        <hr className="program-detail-horizontal-line" />
                                </li>
                                {/* <li>
                                    <h4>16 subjects</h4>
                                    <p>Curriculum</p>
                                </li> */}
                                <li>
                                <p>Term 1 (online) </p>
                                    <h4>{this.props.Term1Info}</h4>
                                    <hr className="program-detail-horizontal-line" />
                                </li>
                                <li>
                                <p>Year 2 / 3 (on campus)</p>
                                    <h4>{this.props.Year3Info}</h4>
                                </li>
                            </ul>
                            } 
                        </div>
                    </div>
                </div>
            </div>
            :""}
            </div>
  )
}

}

export default InstituteTabs;